import { Controller } from "stimulus";
import SignaturePad from "signature_pad";

export default class extends Controller {
  static targets = [
    "approverName",
    "approverCredentials",
    "signaturePad",
    "signatureData",
    "submitButton",
  ];

  connect() {
    console.log("Attendance approval controller connected");

    // Get elements via DOM queries as fallback for Stimulus 1.x
    this.approverNameEl =
      this.element.querySelector(
        '[data-target="attendance-approval.approverName"]'
      ) || document.getElementById("approver_name");
    this.approverCredentialsEl =
      this.element.querySelector(
        '[data-target="attendance-approval.approverCredentials"]'
      ) || document.getElementById("approver_credentials");
    this.signaturePadEl =
      this.element.querySelector(
        '[data-target="attendance-approval.signaturePad"]'
      ) || document.getElementById("signature-pad");
    this.signatureDataEl =
      this.element.querySelector(
        '[data-target="attendance-approval.signatureData"]'
      ) || document.querySelector('input[name="signature_data"]');
    this.submitButtonEl =
      this.element.querySelector(
        '[data-target="attendance-approval.submitButton"]'
      ) || document.getElementById("submit-btn");

    if (!this.signaturePadEl) {
      console.error("Signature pad canvas not found");
      return;
    }

    // Setup canvas size first (without scaling context - let SignaturePad handle it)
    this.setupCanvas();

    // Initialize SignaturePad
    this.signaturePadInstance = new SignaturePad(this.signaturePadEl, {
      backgroundColor: "rgb(255, 255, 255)",
      penColor: "rgb(0, 0, 0)",
    });

    // Bind the callbacks
    this.signaturePadInstance.addEventListener("endStroke", () => {
      console.log("Stroke ended");
      this.updateSignatureData();
    });

    // Handle window resize for responsive canvas
    this.resizeHandler = this.handleResize.bind(this);
    window.addEventListener("resize", this.resizeHandler);

    // Highlight buttons on selection
    this.approveBtn = this.element.querySelector(
      '[data-action*="selectApprove"]'
    );
    this.denyBtn = this.element.querySelector('[data-action*="selectDeny"]');

    this.validateForm();
  }

  disconnect() {
    if (this.signaturePadInstance) {
      this.signaturePadInstance.off();
    }
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler);
    }
  }

  setupCanvas() {
    if (!this.signaturePadEl) return;

    const canvas = this.signaturePadEl;
    const container = canvas.parentElement;

    // Set display size via CSS
    canvas.style.width = "100%";
    canvas.style.height = "200px";

    // Set the canvas internal dimensions to match display size
    // Use the container's actual width
    const displayWidth = container.clientWidth || 400;
    const displayHeight = 200;

    canvas.width = displayWidth;
    canvas.height = displayHeight;
  }

  handleResize() {
    if (!this.signaturePadEl || !this.signaturePadInstance) return;

    // Save current signature data before resize
    const data = this.signaturePadInstance.toData();

    // Resize canvas
    this.setupCanvas();

    // Clear and restore
    this.signaturePadInstance.clear();
    if (data && data.length > 0) {
      this.signaturePadInstance.fromData(data);
    }
  }

  selectApprove(event) {
    document.getElementById("approved").value = "true";
    // Visual feedback - make selection very obvious
    if (this.approveBtn) {
      this.approveBtn.classList.add("selected-approve");
      this.approveBtn.classList.remove("not-selected");
    }
    if (this.denyBtn) {
      this.denyBtn.classList.remove("selected-deny");
      this.denyBtn.classList.add("not-selected");
    }
    this.validateForm();
  }

  selectDeny(event) {
    document.getElementById("approved").value = "false";
    // Visual feedback - make selection very obvious
    if (this.denyBtn) {
      this.denyBtn.classList.add("selected-deny");
      this.denyBtn.classList.remove("not-selected");
    }
    if (this.approveBtn) {
      this.approveBtn.classList.remove("selected-approve");
      this.approveBtn.classList.add("not-selected");
    }
    this.validateForm();
  }

  clearSignature() {
    if (this.signaturePadInstance) {
      this.signaturePadInstance.clear();
      this.updateSignatureData();
    }
  }

  updateSignatureData() {
    if (this.signatureDataEl && this.signaturePadInstance) {
      this.signatureDataEl.value = this.signaturePadInstance.isEmpty()
        ? ""
        : this.signaturePadInstance.toDataURL();
      this.validateForm();
    }
  }

  validateForm() {
    const approvedSelected = document.getElementById("approved").value !== "";
    const nameFilled =
      this.approverNameEl && this.approverNameEl.value.trim() !== "";
    const credentialsFilled =
      this.approverCredentialsEl &&
      this.approverCredentialsEl.value.trim() !== "";
    const signatureFilled =
      this.signatureDataEl && this.signatureDataEl.value.trim() !== "";

    if (this.submitButtonEl) {
      if (
        approvedSelected &&
        nameFilled &&
        credentialsFilled &&
        signatureFilled
      ) {
        this.submitButtonEl.disabled = false;
      } else {
        this.submitButtonEl.disabled = true;
      }
    }
  }
}
